var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeUpVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 11.970563741713704,
    width: 11.970563741712795,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.985281870855541, 5.985281870856279) rotate(225) translate(-5.985281870855541, -5.985281870856279)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 1,
    opacity: 1,
    fillRule: "evenodd",
    d: "M9.48959355725082 1.7322335420470196L10.196700338437374 10.238330199665539L1.7738634032737082 9.53122341847899L9.48959355725082 1.7322335420470196Z",
    fill: "#36D896"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeUpVerde);
export default __webpack_public_path__ + "static/media/icone-up-verde.66a3ef2a42a8a562a1d0476dd5d50f0c.svg";
export { ForwardRef as ReactComponent };